import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

/// ページトップまで戻るボタンコンポーネント
const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  /// スクロール位置を監視してボタンの表示/非表示を制御
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  /// ページトップまでスムーズスクロール
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="ページトップに戻る"
      title="ページトップに戻る"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" className="scroll-icon">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
      </svg>
    </button>
  );
};

export default ScrollToTop; 